export default {
  'primary': '#202242',
  'secondary': '#24CBDC',
  'accent': '#202242'
}
